import { render, staticRenderFns } from "./Policy.vue?vue&type=template&id=1cb41f6b&scoped=true"
import script from "./Policy.vue?vue&type=script&lang=js"
export * from "./Policy.vue?vue&type=script&lang=js"
import style0 from "./Policy.vue?vue&type=style&index=0&id=1cb41f6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb41f6b",
  null
  
)

export default component.exports